import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { getConnectedStores, getStoresIsLoaded } from '~/selectors/stores.selectors';

import { type SetUserVariables } from './useFullStoryUserVars';

/**
 * Forwards user's store connections to FullStory.
 */
export const useFullStoryStoreConnections = ({
  setUserVariables,
}: {
  setUserVariables: SetUserVariables;
}) => {
  const areStoresLoaded = useSelector(getStoresIsLoaded);
  const connectedStores = useSelector(getConnectedStores);

  useEffect(() => {
    if (!areStoresLoaded) return;

    const uniqueConnectedStoreNames = [
      ...new Set(connectedStores.map((store) => store.storePlatform.name)),
    ];
    setUserVariables({ connectedStores: uniqueConnectedStoreNames });
  }, [areStoresLoaded, setUserVariables, connectedStores]);
};
